export const householdAccounts = (getState, householdId) =>
  getState("householdAccountIds", householdId).reduce(
    (accounts, accountId) =>
      Object.assign(accounts, {
        [accountId]: getState("accounts", accountId)
      }),
    {}
  )

export const householdProperties = (getState, householdId) =>
  getState("householdPropertyIds", householdId).reduce(
    (properties, propertyId) =>
      Object.assign(properties, {
        [propertyId]: getState("properties", propertyId)
      }),
    {}
  )

export const householdBenefits = (getState, householdId) =>
  getState("householdBenefitIds", householdId).reduce(
    (benefits, benefitId) =>
      Object.assign(benefits, {
        [benefitId]: getState("benefits", benefitId)
      }),
    {}
  )

export const householdEmployers = (getState, householdId) =>
  getState("householdEmployerIds", householdId).reduce(
    (employers, employerId) =>
      Object.assign(employers, {
        [employerId]: getState("employers", employerId)
      }),
    {}
  )

export const householdIncomes = (getState, householdId) =>
  getState("householdIncomeIds", householdId).reduce(
    (incomes, incomeId) =>
      Object.assign(incomes, {
        [incomeId]: getState("incomes", incomeId)
      }),
    {}
  )

export const householdPeople = (getState, householdId) =>
  getState("householdPersonIds", householdId).reduce(
    (people, personId) =>
      Object.assign(people, {
        [personId]: getState("people", personId)
      }),
    {}
  )

export const householdScenarios = (getState, householdId) =>
  getState("householdScenarioIds", householdId).reduce(
    (scenarios, scenarioId) =>
      Object.assign(scenarios, {
        [scenarioId]: getState("scenarios", scenarioId)
      }),
    {}
  )

export const householdConnections = (getState, householdId) =>
  getState("householdConnectionsIds", householdId).reduce(
    (connections, connectionId) =>
      Object.assign(connections, {
        [connectionId]: getState("connections", connectionId)
      }),
    {}
  )

export const householdConnectionLinks = (getState, householdId) =>
  getState("householdConnectionLinksIds", householdId).reduce(
    (connectionLinks, connectionLinksId) =>
      Object.assign(connectionLinks, {
        [connectionLinksId]: getState("connectionLinks", connectionLinksId)
      }),
    {}
  )

export const scenarioGoals = (getState, scenarioId) =>
  getState("scenarioGoalIds", scenarioId).reduce(
    (goals, goalId) =>
      Object.assign(goals, {
        [goalId]: getState("goals", goalId)
      }),
    {}
  )
export const householdIncomeBreakdowns = (getState, householdId) =>
  getState("incomeBreakdowns", householdId)

export const currentUserHouseholds = getState => {
  const { group_id } = getState("user")
  return getState("householdIds", group_id).map(householdId =>
    getState("households", householdId)
  )
}
export const scenarioProposals = (getState, scenarioId) =>
  getState("scenarioProposalIds", scenarioId).reduce(
    (proposalStatuses, proposalId) =>
      Object.assign(proposalStatuses, {
        [proposalId]: getState("proposalStatuses", proposalId)
      }),
    {}
  )

export const isReviewHousehold = getState => {
  const { group_id } = getState("user")
  const currentHouseholdId = getState("userState", "currentHouseholdId")
  return !group_id || !currentHouseholdId
    ? false
    : !getState("householdIds", group_id).includes(currentHouseholdId)
}
